export const POLLING_INTERVAL = 200;
export const POLLING_INTERVAL_SLOW = 1000;
export const OUTPUT_TTL = '!'; // ~596 hours
export const OUTPUT_SHORT_TTL = 3 * 1000; // 3 secs

export class PacVersionData {
  constructor(data) {
    this.uid = data.uid;
    this.firmware = data.firmware;
    this.version = data.version;
  }
}
